import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import { toast } from '@/lib/toast';
import i18n from '@/plugins/i18n';

/**
 * Хранилище для диалоговых окон
 * */
export const useDialogStore = defineStore('dialog', () => {
    const currentDialog = shallowRef(null)

    function openDialog(component, props = {})
    {
        try {
            currentDialog.value = { component, props };
        } catch (error) {
            toast.error(i18n.global.t(`Не удалось открыть модальное окно. Ошибка: {_1}`, {'_1': error.message}))
        }
    }

    function closeDialog()
    {
        currentDialog.value = null;
    }

    return { currentDialog, openDialog, closeDialog }
})